export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./calendar.vue?vue&type=template&id=0f190464&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/calendar.vue?vue&type=template&id=0f190464&
// module id = 927
// module chunks = 0